<script setup lang="ts">
/**
 * 全局 Toast 容器, 在 App.vue 顶层挂载一次。
 * 视觉:屏幕顶部居中, 多条堆叠, 渐入渐出。
 * 移动端:同样位置, 不挡 topbar。
 */

import { useNotificationsStore } from '@/stores/notifications'

const notif = useNotificationsStore()

const colorClass: Record<string, string> = {
  info:    'bg-neutral-900/95 border-white/20  text-neutral-200',
  success: 'bg-emerald-900/95 border-emerald-400/40 text-emerald-100',
  error:   'bg-red-900/95     border-red-400/40    text-red-100',
}
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-x-0 top-0 z-[1000] pointer-events-none
             flex flex-col items-center gap-2 pt-safe-top px-4"
      aria-live="polite"
      aria-atomic="false"
    >
      <TransitionGroup
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 -translate-y-2"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0 -translate-y-1"
      >
        <div
          v-for="toast in notif.toasts"
          :key="toast.id"
          class="pointer-events-auto mt-2 max-w-md w-full sm:w-auto
                 rounded-lg border px-4 py-2 text-sm shadow-lg
                 backdrop-blur-sm cursor-pointer"
          :class="colorClass[toast.severity]"
          role="status"
          @click="notif.dismiss(toast.id)"
        >
          {{ toast.text }}
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
